var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-btn',{staticClass:"w-btn-small page-back-btn",attrs:{"color":"primary","text":"","data-test-id":"go-back-btn"},on:{"click":_vm.on_click}},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("$vuetify.icons.chevron_backward")]),_vm._v(_vm._s(_vm.l.t('app.back-lowercase', 'back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }